import React, { useEffect, useState, useRef } from "react"
import RootFrame from 'pages/components/RootFrame'
import { RouteRoot } from 'pages/routes/Router'
import { generatePath, matchPath, useLocation, useNavigate, useSearchParams } from "react-router-dom"

const CustomContext =React.createContext({})

function useSyncState(initValue){
  const ref = useRef(initValue)
  const state =useState(initValue)
  // ref.current = initValue

  function setValue(value) {
    ref.current = value
    state[1](value)
  }

  return [state[0], setValue, ref]
}

function usePathname(){
  const location =useLocation()
  const pathname =useSyncState(null)
  useEffect(()=>{
    pathname[1](location.pathname)
  }, [location])

  return pathname
}

function cls(...classes) {
  return classes.filter(Boolean).join(' ')
}

function Root(){
  const [drawerWidth, setDrawerWidth] =useState(0)
  
  // const directionState =useRef(0)
  const portraitmode =useSyncState(false)
  
  const drawerState =useSyncState(false)
  // const goPrevious =useRef(null)
  // const goNext =useRef(null)
  const disableWheelScrolling =useSyncState(false)

  // const isLogin =useSyncState(false)
  // const isLightScrollbark =useSyncState(false)

  // const campaignData =useSyncState(undefined)
  const manualData =useSyncState(undefined)
  const filteredManualData =useSyncState(undefined)
  const currCategory =useSyncState(undefined)

  // const guess_number_processing =useSyncState(-1)
  // const guess_number_ref =useRef(null)

  const alertDlgState =useSyncState(false)
  const alertTitle =useSyncState('TITLE')
  const alertMessage =useSyncState('MESSAGE')

  const parentHtmlRef =useRef(null)
  

  const handleResize =(force_run)=>{
    // if (window.innerWidth/window.innerHeight>=1 || force_run===true){
      let vh =window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)

      const width =Math.min(window.innerWidth, 410/1136*window.innerHeight)
      setDrawerWidth(width)
    // }

    if (document.documentElement.clientWidth/document.documentElement.clientHeight>=1){
      portraitmode[1](false)
    }else{
      portraitmode[1](true)
    }
  }
  
  //To stop the touch event from being passed to the webview
  const interceptTouchMove =(e)=>{
    let target = e.target;

    // Recursively check if any parent has the 'data-allow-touch-move' attribute
    while (target) {
        if (target.hasAttribute("data-allow-touch-move")) {
            return; // Allow touch move (do not call preventDefault)
        }
        target = target.parentElement; // Move to the parent node
    }
    
    e.preventDefault()
  }
  
  useEffect(()=>{

    //convert hover --> active for mobile platform
    if ('ontouchstart' in document.documentElement) {
      console.log('244 - modify css rule from :hover --> :active')

      const styleSheets = Array.from(document.styleSheets).filter(
        (styleSheet) => !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
      )
      for (let sheet of styleSheets) {
        if (sheet instanceof CSSStyleSheet && sheet.cssRules) {
          
          for (var ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
            var rule = sheet.cssRules[ruleI];

            if (rule.selectorText) {
              rule.selectorText = rule.selectorText.replace(':hover', ':active');
            }
          }

        }
      }

    }    

    //prevent image context menu on mobile devices
    document.body.style.webkitTouchCallout='none';

    //prevent pull-down reload
    document.body.style.overscrollBehavior='contain';

    handleResize(true)
    window.addEventListener('resize', handleResize)
    window.addEventListener("touchmove", interceptTouchMove, {passive: false});
    return ()=>{
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('touchmove', interceptTouchMove)
    }
  },[])


  const cxtProviderVal ={
    // directionState:directionState,
    portraitMode:portraitmode,

    drawerState:drawerState,
    drawerWidth:{},
    // goNext: goNext,
    // goPrevious: goPrevious,
    disableWheelScrolling: disableWheelScrolling,

    // isLightScrollbark: isLightScrollbark,

    // isLogin: isLogin,
    // campaignData: campaignData,
    // guess_number_processing: guess_number_processing,
    // guess_number: guess_number_ref,
    manualData: manualData,
    filteredManualData: filteredManualData,
    currCategory: currCategory,

    alertDlgState: alertDlgState,
    alertTitle: alertTitle,
    alertMessage: alertMessage,

    parentHtmlRef: parentHtmlRef,
  }

  return (
    <CustomContext.Provider value={cxtProviderVal}>
      <RootFrame>
        <RouteRoot />
      </RootFrame>
    </CustomContext.Provider>
  )
}
export {Root, CustomContext, cls, useSyncState, usePathname}